import { motion } from 'framer-motion6';
import { ReactComponent as FeatherImg } from 'products/global/assets/img/join-us/feather-white.svg';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  width: 290px;
  height: 262px;
  display: flex;
  justify-content: center;
`;

export const Card = styled.div`
  position: relative;
  height: 262px;
  perspective: 1000px;
  width: ${({ cardWidth }) => `${cardWidth}px`};
  margin-right: ${({ marginRight }) => `${marginRight}px`};
`;

export const Flip = styled(motion.div)`
  transform-style: preserve-3d;
  width: 100%;
  height: 100%;
  position: relative;
  box-shadow: 0px 8px 32px rgba(15, 23, 42, 0.16);
  border-radius: 20px;
`;

export const Front = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 18px 15px 22px 20px;
  background-color: ${({ frontBg }) => frontBg};
  flex-direction: column;
  justify-content: space-between;
  backface-visibility: hidden;
  transform: rotateY(0deg);
  border-radius: 20px;
`;

export const Back = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ backBg }) => backBg};
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: rotateY(180deg);
  padding: 21px;
  border-radius: 20px;

  > span {
    font-family: 'Times New Roman';
    font-style: italic;
  }
`;

export const Feather = styled(FeatherImg)`
  height: 56px;
  width: 29px;
  align-self: flex-end;
  position: absolute;
`;

export const Name = styled.h2`
  margin: 0;
  margin-top: auto;
  font-size: 44px;
  line-height: 49px;
`;

export const Description = styled.p`
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -1px;
  margin: 0;
  margin-top: auto;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > h3 {
    font-size: 16px;
    margin: 0px;
  }

  > span {
    font-family: 'Times New Roman';
    font-style: italic;
  }
`;
